module.exports = __webpack_public_path__ + "static/media/icon.95c75781.png";